document.addEventListener("DOMContentLoaded", () => {
  let next_url;

  async function getNextPage() {
    const products_on_page = document.getElementById("product-grid");
    if (products_on_page) {
      next_url = products_on_page.dataset.nextUrl;
    }

    if (!next_url) {
      return;
    }

    try {
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    }
  }

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("load-more_btn")) {
      e.preventDefault();
      loadMoreProducts();
    }
  });

  async function loadMoreProducts() {
    const load_more_btn = document.querySelector(".load-more_btn");
    const load_more_spinner = document.querySelector(".load-more_spinner");
    load_more_btn.style.display = "none";
    load_more_spinner.style.display = "block";
    let nextPage = await getNextPage();
    if (!nextPage) {
      load_more_spinner.style.display = "none";
      return;
    }

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, "text/html");

    load_more_spinner.style.display = "none";

    const productgrid = nextPageDoc.getElementById("product-grid");
    const new_products = productgrid.getElementsByClassName("grid__item");
    const new_url = productgrid.dataset.nextUrl;
    console.log("New URL:", new_url);

    if (new_url) {
      load_more_btn.style.display = "block";
    }
    next_url = new_url;
    const products_on_page = document.getElementById("product-grid");
    products_on_page.dataset.nextUrl = next_url;
    for (let i = 0; i < new_products.length; i++) {
      products_on_page.appendChild(new_products[i]);
    }
  }
});
